import type { GATriggerProps } from "@similarweb/ga-connect";
import { GAContextProviders, GATrigger } from "@similarweb/ga-connect";

import { useApiConfig } from "./useApiConfig";
import { useBoundaryErrorHandler } from "./useBoundaryErrorHandler";

export type GaTriggerContainerProps = Omit<GATriggerProps, "onBoundaryError">;

export const GaTriggerContainer = (props: GaTriggerContainerProps) => {
    const apiConfig = useApiConfig();
    const boundaryErrorHandler = useBoundaryErrorHandler();

    return (
        <GAContextProviders apiConfig={apiConfig}>
            <GATrigger
                {...props}
                onBoundaryError={boundaryErrorHandler}
            />
        </GAContextProviders>
    );
};
